<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增科室"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}"  autocomplete="off">
            <el-form-item label="科室全称" prop="department_name">
                <el-input type="text" v-model="ruleForm.department_name" placeholder="请输入科室全称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="运营负责公司" prop="company_id">
                <el-select @change="changeCompany" v-model="ruleForm.company_id" placeholder="请选择运营负责公司"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责部门">
                <el-select @change="changeDeparment" v-model="ruleForm.department_id"
                           placeholder="请选择运营负责部门"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyDeparment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责组">
                <el-select v-model="ruleForm.group_id"  @change="changeGroup" placeholder="请选择运营负责组"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyGroup"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="特属服务专员">
                <el-select v-model="ruleForm.operate_user_ids"
                           multiple
                           placeholder="请选择特属服务专员"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allGroupUser"
                        :key="item.id"
                        :label="item.user_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序号" prop="sort">
                <el-input type="number" v-model="ruleForm.sort" placeholder="请输入排序号 (排序值越小越前)" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="科室图标">
                <div>
                    <div style="float:left;margin-left: 2px;">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_up" placeholder="科室选中图标"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            accept=".png,.PNG"
                            :action="upload_path"
                            :show-file-list="false"
                            :on-success="handleIconActivedImgSuccess"
                            :before-upload="beforeAvatarUpload"
                            :limit="1">
                            <img style=" width: 50px;height: 50px;" v-if="imageIconActivedUrl" :src="imageIconActivedUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传png格式的科室选中图标</div>
                    </div>
                    <div style="float: left;margin-left: 20px;">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_down" placeholder="科室未选中图标"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            accept=".png,.PNG"
                            :action="upload_path"
                            :show-file-list="false"
                            :on-success="handleIconImgSuccess"
                            :before-upload="beforeAvatarUpload"
                            :limit="1">
                            <img style=" width: 50px;height: 50px;" v-if="imageIconUrl" :src="imageIconUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传png格式的科室未选中图标</div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        created() {
            if (isMobile()) {
                this.form_width = "100%"
            }
            if (this.$route.params.hospital_id) {
                this.ruleForm.hospital_id = this.$route.params.hospital_id;
                this.hospitalDisabled = true;
            }
        },
        mounted() {
            this.createParams();
        },
        data() {
            return {
                upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                imageIconUrl: '',
                imageIconActivedUrl: '',
                hospitalDisabled: false,
                allCompany: [],
                allCompanyDeparment: [],
                allCompanyGroup: [],
                allGroupUser: [],
                allHospital: [],
                ruleForm: {
                    department_name: "",
                    hospital_id: "",
                    sort: "10",
                    status: 1,
                    icon: 1,
                    icon_actived: 1,
                    company_id: '',
                    department_id: '',
                    group_id: '',
                    expert_id: '',
                    operate_user_id: '',
                    operate_user_ids: [],
                },
                rules: {
                    department_name: [
                        {required: true, message: "请输入科室全称", trigger: "blur"},
                    ],
                    sort: [
                        {required: true, message: "请输入排序号", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],
                },
                is_submit: false,
                form_width: "40%",
            };
        },
        methods: {

            // 返回上一页
            goBack() {
                window.history.go(-1);
                // this.$router.push({
                //     name: "hospitalNewDeparmentList",
                //     params: {}
                // });
                // window.close()
            },
            // 所有运营单位
            createParams() {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'createParams',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompany = res.data.data.company;

                    if (this.role_id == 3) {
                        this.ruleForm.company_id = this.userData.company_id
                        this.changeCompany()
                    }
                });
            },
            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminNewOperateServices',
                            'method': 'createHospitalDeparment',
                            'params': {
                                department_name: this.ruleForm.department_name,
                                sort: this.ruleForm.sort,
                                status: this.ruleForm.status,
                                icon: this.ruleForm.icon,
                                icon_actived: this.ruleForm.icon_actived,
                                company_id: this.ruleForm.company_id,
                                department_id: this.ruleForm.department_id,
                                group_id: this.ruleForm.group_id,
                                operate_user_ids: this.ruleForm.operate_user_ids,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '创建成功',
                                duration: 1500,
                                onClose: function () {
                                    // window.history.go(-1);
                                    _that.is_submit = false;
                                    _that.$router.push({
                                        name: "hospitalNewDeparmentList",
                                        params: {}
                                    });
                                }
                            });
                        }).catch(()=>{
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
            },
            //上传图片之前，检测文件格式
            beforeAvatarUpload(file) {
                if (file.type === 'image/png') {
                    var isJPG = true;
                } else {
                    var isJPG = false;
                }
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isJPG) {
                    this.$message.error('图片只能是png格式!');
                }
                return isJPG;
            },
            handleIconImgSuccess(res) {
                if (res.code == 0) {
                    this.ruleForm.icon = res.data;
                    this.imageIconUrl = this.imgUrl + res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            },
            handleIconActivedImgSuccess(res) {
                if (res.code == 0) {
                    this.ruleForm.icon_actived = res.data;
                    this.imageIconActivedUrl = this.imgUrl + res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            },
            changeCompany() {
                this.ruleForm.department_id = '';
                this.ruleForm.group_id = '';
                this.ruleForm.operate_user_id = '';
                this.getAllDeparment();
            },
            changeDeparment() {
                this.ruleForm.group_id = '';
                this.ruleForm.operate_user_id = '';
                this.getAllCompanyGroup();
            },
            getAllDeparment() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyDeparment',
                    params: {
                        company_id: this.ruleForm.company_id,
                        status: 1
                    }
                };
                this.allCompanyDeparment = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    this.allCompanyDeparment = res.data.data;

                    if (this.role_id == 3) {
                        this.ruleForm.department_id = this.userData.department_id
                        this.changeDeparment()
                    }
                });
            },

            getAllCompanyGroup() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyGroup',
                    params: {
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompanyGroup = res.data.data;
                    if (this.role_id == 3) {
                        this.ruleForm.group_id = this.userData.group_id
                        this.changeGroup()
                    }
                });
            },
            // 获取组成员
            changeGroup() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllGroupUser',
                    params: {
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        group_id: this.ruleForm.group_id,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allGroupUser = res.data.data;
                    if (this.role_id == 3 && this.userData.child_role_id > 0) {
                        this.ruleForm.operate_user_id = this.userData.id
                    }
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .avatar-btn, .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }
    .el-upload.el-upload--text{
        width: 50px !important;
        height: 50px !important;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
